import { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FormFuncionarios } from '../../../components/Forms/FormFuncionarios'
import FuncionariosService from '../../../services/database/FuncionariosService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

import { toast } from 'react-toastify'
import './styles.css'

export function ModalCadFunc({ isOpen, onClose, loadFuncionarios }) {
  const [requestIsLoading, setRequestIsLoading] = useState(false)

  const formFuncionariosRef = useRef(null)

  async function handleSubmit(data) {
    setRequestIsLoading(true)

    try {
      await FuncionariosService.create(data)

      formFuncionariosRef.current?.resetForm()

      toast.success('Funcionário cadastrado com sucesso!')
      await loadFuncionarios()
      onClose()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao cadastrar funcionário!')
    } finally {
      setRequestIsLoading(false)
    }
  }

  return (
    <Modal
      centered
      dialogClassName="custom-modalzpl"
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title> Cadastrar Funcionário</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormFuncionarios
          ref={formFuncionariosRef}
          onClose={onClose}
          onSubmit={handleSubmit}
          requestIsLoading={requestIsLoading}
          buttonSubmitText="Cadastrar"
        />
      </Modal.Body>
    </Modal>
  )
}
